import React, { useEffect, useRef, useState, useCallback } from 'react';
import Styled from './index.style';
import flowImg1 from 'assets/images/event/250713/flow.jpg';
import flowImg2 from 'assets/images/event/250713/flow2.jpg';
import flowImg3 from 'assets/images/event/250713/flow3.jpg';
import flowImg4 from 'assets/images/event/250713/flow4.jpg';
import flowImg5 from 'assets/images/event/250713/flow5.jpg';
import flowImg6 from 'assets/images/event/250713/flow6.jpg';

import { Trans, useTranslation } from 'react-i18next';
import { Link, Switch, useHistory, useLocation } from 'react-router-dom';
import { openLink } from 'common/util/util';
import useLoginStatus from "common/hook/useLoginStatus";
import { ModalContext } from "component/Modal/modalContext";
import Login from "component/user/Login";


import DefaultTextModal from 'component/Modal/DefaultTextModal';
import { useSelector } from "react-redux";
import { useAxios } from "common/hook/useAxiosHook";
import plansApi from "api/plans";
import PurchasePackageModal from "../../BookStorePage/PurchasePackageModal";

const EventPage = () => {
  const language = localStorage.getItem('i18nextLng');
  const { t } = useTranslation('event/20250713Topik');

  const today = new Date().getTime();
  const dday = new Date("2025-07-13T00:00:00").getTime();
  const gap = dday - today;
  const reday = Math.ceil(gap / (1000 * 60 * 60 * 24));

  const isLogin = useLoginStatus();
  let { handleModal } = React.useContext(ModalContext);
  const location = useLocation();


  const token = useSelector((state) => state.user.token);
  const [{ data: planData }] = useAxios(() => plansApi.getPlan(token), []);


  const history = useHistory();

  const showPurchaseModal = () => {

    if(!isLogin) {
      handleModal(<Login/>, false, 420, location.pathname);
      return;
    }

    let bookItem = {
      id: 1316,
      type: 'Book',
      name: 'TOPIK 2 합격 패키지',
      price: 44000,
      priceDollar: 30.0,
      discountCost: 1000,
      discountCostDollar: 0.1,
      globalBookUrl: '',
    };
    handleModal(<PurchasePackageModal data={bookItem} url={''} />, false, 500);

  };


  const checkLogin = useCallback((e) => {
    if (!isLogin) {
      e.preventDefault(); //로그인 안한 경우 Link to 기능 무효화
      handleModal(<Login />, false, 420, location.pathname);
      return;
    /*
    } else {
      if (planData.currentPlan === "FREE") {
        const item = planData.plans.find((item) => item.productId === 1147);
        history.push({
          pathname: `/plan-payment/${item.planCode.toLowerCase()}`,
          search: `?productId=${item.productId}`,
          state: item,
        });
      } else {
        handleModal(<DefaultTextModal
          title={t(language === 'ko-KR' ? '이미 멤버십 구독 중입니다.' : 'You are already subscribing to the membership.')}
          btnType={'primary'}
        />);
      }
     */
    }
  }, [planData]);

  return (
    <Styled.EventWrap className={language === 'ko-KR' ? 'ko' : null}>
      <div className='visual'>
        <div className='dday'>
          {t('visual.dday')} <strong>D-<span>{reday}</span></strong>
        </div>
        <div className='blind'>
          <h2>{t('visual.title')}</h2>
          <p>{t('visual.desc')}</p>
        </div>
      </div>

      <div className='package'>
        <div className='inner'>
          {language === 'ko-KR' ? (
            <Styled.Title color="#fff45c" colorH2="#fff45c">
              <Trans t={t}>package.title</Trans>
              <h2><Trans t={t}>package.title-2</Trans></h2>
            </Styled.Title>
          ) : (
            <Styled.Title color="#fff45c" colorH2="#fff45c">
              <h2><Trans t={t}>package.title</Trans></h2>
              <Trans t={t}>package.title-2</Trans>
            </Styled.Title>
          )}
          <div className="package-wrap">
            <div className="card">
              <div className="tit"><Trans t={t}>package.tit</Trans></div>
              <div className="img img1"></div>
              <div className="desc"><Trans t={t}>package.desc</Trans></div>
            </div>
            <div className="card">
              <div className="tit"><Trans t={t}>package.tit2</Trans></div>
              <div className="img img2"></div>
              <div className="desc"><Trans t={t}>package.desc2</Trans></div>
            </div>
          </div>
        </div>
      </div>

      <div className='curriculum'>
        <div className='inner'>
          {language === 'ko-KR' ? (
            <Styled.Title color="#333333" colorH2="#0250fa">
              <Trans t={t}>curriculum.title</Trans>
              <h2><Trans t={t}>curriculum.title-2</Trans></h2>
            </Styled.Title>
          ) : (
            <Styled.Title color="#333333" colorH2="#0250fa">
              <h2><Trans t={t}>curriculum.title</Trans></h2>
              <Trans t={t}>curriculum.title-2</Trans>
            </Styled.Title>
          )}
          <Styled.TabCont>
            <div className="tab-tit">
              <h3>{t('curriculum.tab-tit')}</h3>
            </div>
            <div className='tab-cont cont'></div>
            <div className='blind'>
            </div>
          </Styled.TabCont>
        </div>
      </div>

      <div className='report'>
        <div className='inner'>
          <Styled.Title color={"#4b2a00"} colorH2={"#3d1d8a"}>
            <Trans t={t}>report.title</Trans>
            <h2><Trans t={t}>report.title-2</Trans></h2>
          </Styled.Title>
          <div className="flow_screen">
            <div className="flow_banner group1">
              <ul>
                <li><img src={flowImg1} alt=""/></li>
                <li><img src={flowImg2} alt=""/></li>
                <li><img src={flowImg3} alt=""/></li>
              </ul>
              <ul>
                <li><img src={flowImg4} alt=""/></li>
                <li><img src={flowImg5} alt=""/></li>
                <li><img src={flowImg6} alt=""/></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className='plan'>
        <div className='inner'>
          <Styled.Title color={"#f9f9f9"} colorH2={"#f9f9f9"}>
            <Trans t={t}>plan.title</Trans>
            <h2><Trans t={t}>plan.title-2</Trans></h2>
          </Styled.Title>
          <div className='plan-wrap'>
            <div className='card'>
              <div className='tit green'>
                <h3>{t('plan.plan')}</h3>
              </div>
              <div className="cnt">
                <dl>
                  <dt><Trans t={t}>plan.course.lb</Trans></dt>
                  <dd><Trans t={t}>plan.course.cont</Trans></dd>
                </dl>
                <dl>
                  <dt><Trans t={t}>plan.mocktest.lb</Trans></dt>
                  <dd><Trans t={t}>plan.mocktest.cont</Trans></dd>
                </dl>
                <dl>
                  <dt><Trans t={t}>plan.period.lb</Trans></dt>
                  <dd>{t('plan.period.cont')}</dd>
                </dl>
              </div>
              <button className='btn green' onClick={showPurchaseModal}>
                <div className="in">
                  <Trans t={t} className='price'>plan.price</Trans>
                  <Styled.icoArrow2 className='apply'><span>{t('plan.apply')}</span></Styled.icoArrow2>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className='notification'>
        <div className='inner'>
          <h3>{t('notification.title')}</h3>
          <ul>
            <li><Trans t={t}>notification.desc</Trans></li>
            <li><Trans t={t}>notification.desc2</Trans></li>
          </ul>
        </div>
      </div>
    </Styled.EventWrap>
  );
};

export default EventPage;